(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const reveal = (root = document) => {
    const items = root.querySelectorAll('[data-tohfa-reveal]');
    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: .12, rootMargin: '0px 0px -30px' });
    items.forEach((item) => {
      item.classList.add('tohfa-theme-reveal');
      observer.observe(item);
    });
  };

  const watchInstagramEmbeds = (root = document) => {
    root.querySelectorAll('.tohfa-video-frame--instagram').forEach((frame) => {
      const markReady = () => {
        if (frame.querySelector('iframe')) frame.classList.add('is-embed-ready');
      };
      markReady();
      if (!frame.classList.contains('is-embed-ready') && 'MutationObserver' in window) {
        const observer = new MutationObserver(() => {
          markReady();
          if (frame.classList.contains('is-embed-ready')) observer.disconnect();
        });
        observer.observe(frame, { childList: true, subtree: true });
        window.setTimeout(() => observer.disconnect(), 15000);
      }
    });
  };

  const ready = () => {
    document.body.classList.add('tohfa-page-ready');
    reveal();
    if (window.instgrm) window.instgrm.Embeds.process();
    watchInstagramEmbeds();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();

  document.addEventListener('shopify:section:load', (event) => {
    reveal(event.target);
    if (event.target.querySelector('.instagram-media') && window.instgrm) window.instgrm.Embeds.process();
    watchInstagramEmbeds(event.target);
  });
  document.addEventListener('click', (event) => {
    if (window.Shopify?.designMode || reducedMotion.matches || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || (url.pathname === location.pathname && url.search === location.search && url.hash)) return;
    event.preventDefault();
    document.body.classList.add('tohfa-page-leaving');
    window.setTimeout(() => { location.href = url.href; }, 180);
  });
  window.addEventListener('pageshow', () => document.body.classList.remove('tohfa-page-leaving'));
})();
